import React from 'react'
import * as R from 'ramda'
import config from 'config'

import GlobalLayout from 'src/layouts/global-page'

import request from 'src/lib/data/request'
import { serveRedirect } from 'src/lib/response'

import type { NetworkPageContext } from 'src/types/next'

import { BoardShareLinkView } from 'src/components/board/v2/share-link'
import { UserLogin } from 'src/components/board/v2/share-link/user-login'

interface ShareLinkProps {
  boardId: string
  tokenId: string
  boardTitle: string
  token: string
  networkName: string
  isUserLoggedIn: boolean
}

const BoardShareLinkPage = ({
  boardId,
  token,
  tokenId,
  boardTitle,
  networkName,
  isUserLoggedIn
}: ShareLinkProps) => {
  if (!isUserLoggedIn) {
    return <UserLogin title={boardTitle} token={token} />
  }

  return (
    <BoardShareLinkView
      boardId={boardId}
      boardTitle={boardTitle}
      tokenId={tokenId}
      networkName={networkName}
    />
  )
}

// @ts-expect-error TODO type
BoardShareLinkPage.getLayout = page => (
  <GlobalLayout title="Join Community">{page}</GlobalLayout>
)

BoardShareLinkPage.getInitialProps = async (ctx: NetworkPageContext) => {
  const { res, req, query } = ctx

  const boardShareRes = await request(req, ctx)
    .post(`${config.NEXT_PUBLIC_GALACTUS_URL}/share-token`)
    .send({ token: query.token })

  const resBody = R.prop('body', boardShareRes)
  const { board, network, token, user } = resBody
  const { name, ssoLinksEnabled, rootNetworkName } = network

  if (ssoLinksEnabled) {
    const redirectUrl = `${config.NEXT_PUBLIC_API_URL}/auth/saml/gen-auth-request?networkName=${rootNetworkName}&RelayState=${board.id}`
    serveRedirect(res, null, redirectUrl)
  }

  return {
    boardId: board.id,
    boardTitle: board.title,
    tokenId: token.id,
    token: query.token,
    networkName: name,
    isUserLoggedIn: !R.isNil(user)
  }
}

export default BoardShareLinkPage
